import styled from '@emotion/styled';
import Alert from '@mui/material/Alert';

const StyledErrorAlert = styled(Alert)``;

export default StyledErrorAlert;
